import React, { useEffect, useState } from "react";
import Header from "../../common/Header";
import FooterDashBoard from "../../common/FooterDashBoard";
import DashBoardSideBar from "../../common/DashBoardSideBar";
import ListingSection from "./components/ListingSection";
import DashBoardHeader from "../../common/DashBoardHeader";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../../axiosInstance";

const Listing = () => {
  const [loading,setLoading] = useState(false)
  const [error,setError] = useState("")
  const [data,setData] = useState([])
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate()
  const getAllData = async(p,l,token) => {
    try {
      setError("")
      setLoading(true)
      const response = await axiosInstance.get(`/api/inventory/?page=${p}&limit=${l}`,{
        headers:{
          "Authorization":token
        }
      })
      setData(response?.data?.data)
      setPage(response?.data?.page);
      setTotalPages(response?.data?.totalPages);
      
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError(msg);
        }
        else if (error.request) {
          setError("No response from server. Please check your internet connection.");
        }
        else {
          setError(error.message || "Unexpected error occurred.");
        }
      } else {
        setError("An unexpected error occurred.");
      }
    } finally {
      setLoading(false)
    }
  }
  useEffect(()=>{
    const auth = JSON.parse(localStorage.getItem("auth"))
    if(!auth || !auth.token) return navigate("/")
    getAllData(page,limit,auth.token)
  },[page])
  return (
    <div className="boxcar-wrapper v2">
      <DashBoardHeader dashBoardHeader={true} />
      <section className="dashboard-widget-two">
        <div className="right-box">
          <DashBoardSideBar />
          <div style={{overflowX:"scroll"}} >
          <ListingSection data={data} getAllInventory={getAllData} page={page} setPage={setPage} limit={limit} totalPages={totalPages} loading={loading} error={error}/>
          </div>
        </div>
      </section>
      {/* <FooterDashBoard /> */}
    </div>
  );
};

export default Listing;
